module.exports = __webpack_public_path__ + "img/icon_floating_tv.fd7dafe5.svg";